export { createDriver } from './axios-driver';


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-saga-requests-axios/es/index.js
// module id = 1842
// module chunks = 0